import React, { useEffect, useRef, useState } from "react";
import "../Style/gd.css";

import ServicesSection from "../components/Gdservices";
import CccSection from "../components/Gdccc";
import FutureSection from "../components/Gdfuture";
import GdIndustries from "../components/Gdindustries";

import GdStack from "../components/Gdstack";
import Forms from "../components/Forms";
import DoubtsSection from "../components/gddoubts";
import FeedbackSection from "../components/Clientfeedback";
import FooterSection from "../components/Footer";

function GdPage() {
  const overlayRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (overlayRef.current) observer.observe(overlayRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="gd-page">
        {/* CSS-only pattern layers, no images */}
        <div className="gd-grid-pattern" aria-hidden="true" />
        <div className="gd-blob gd-blob-1" aria-hidden="true" />
        <div className="gd-blob gd-blob-2" aria-hidden="true" />
        <div className="gd-blob gd-blob-3" aria-hidden="true" />

        <div
          className={`gd-overlay ${isVisible ? "gd-visible" : ""}`}
          ref={overlayRef}
        >
          <div className="gd-glass">
            {/* <img
              src={mpeoplesLogo}
              alt="MPeoples Logo"
              className="gd-logo gd-anim gd-anim-1"
            /> */}

            <span className="gd-eyebrow gd-anim gd-anim-2">
              Graphic Design Services
            </span>

            <h1 className="gd-title gd-anim gd-anim-3">
              Creative Designs That Build Strong Brand Identity
            </h1>

            <p className="gd-description gd-anim gd-anim-4">
              At MPeoples, we create impactful graphic designs that clearly communicate your brand message. Our creative visuals help businesses attract attention, engage audiences, and strengthen their brand presence.
            </p>

            <a href="#contactsec">
              <button className="gd-btn gd-anim gd-anim-5">
                Let&rsquo;s Build Together <span>↗</span>
              </button>
            </a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <ServicesSection />
      <CccSection />
      <FutureSection />
      <GdIndustries />
      <GdStack />
      <Forms />
      <DoubtsSection />
      <FeedbackSection />
      <FooterSection />
      {/* <Gdworks /> */}
    </>
  );
}

export default GdPage;